export default __webpack_public_path__ + "static/media/work-5.fe7a5fec.jpg";